/**
 * Hands the browser over to an external URL — the TrueLayer authorise page.
 *
 * Wrapped rather than called inline so the handoff can be asserted in tests:
 * jsdom cannot navigate, and assigning `window.location` there either throws
 * or silently does nothing depending on the version.
 */
export function redirectToExternal(url: string): void {
  window.location.assign(url);
}
